<script setup lang="ts">
import { PageEnum } from "@/enums";
import { useDataLayerStore } from "@/stores";
import editQuoteComponent from "@/components/form/editQuote/EditQuote.vue";
import { EventTypeEnum } from "@/models";
import JourneyLayout from "@/components/layout/JourneyLayout/JourneyLayout.vue";

// Stores
const dataLayer = useDataLayerStore();

const emit = defineEmits<{
    submitSection: [currentPage: PageEnum, nextPage: PageEnum];
}>();

const submitSection = (currentPage: PageEnum, nextPage: PageEnum) => {
    dataLayer.triggerEvent(
        EventTypeEnum.PageInteraction,
        "button|Cover Summary"
    );
    emit("submitSection", currentPage, nextPage);
};
defineExpose({ submitSection });
</script>

<template>
    <JourneyLayout>
        <template #main>
            <div :id="PageEnum.SelectCover">
                <form
                    v-cloak
                    name="form2"
                    method="post"
                    autocomplete="off"
                    data-vv-scope="form2"
                    @submit.prevent
                >
                    <editQuoteComponent @submit-section="submitSection" />
                </form>
            </div>
        </template>
    </JourneyLayout>
</template>
